import { TariffRatesPerType } from '../tariff-types';

export const getDefaultFlatTariffRates = (seasonIndex: number): TariffRatesPerType => {
  return {
    import: [
      {
        seasonIndex,
        chargeType: 'CONSUMPTION_BASED',
        chargeClass: 'SUPPLY',
        transactionType: 'BUY_IMPORT',
        rateBands: [
          {
            sequenceNumber: 1,
            rate: undefined,
            hasConsumptionLimit: false,
            hasDemandLimit: false,
          },
        ],
      },
    ],
    export: [
      {
        seasonIndex,
        chargeType: 'CONSUMPTION_BASED',
        chargeClass: 'SUPPLY',
        transactionType: 'SELL_EXPORT',
        rateBands: [
          {
            sequenceNumber: 1,
            rate: undefined,
            hasConsumptionLimit: false,
            hasDemandLimit: false,
          },
        ],
      },
    ],
  };
};
